import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'item-active': _ctx.active, 'item-inactive': !_ctx.active })
  }, _toDisplayString(_ctx.active ? 'Ativo' : 'Inativo'), 3))
}